import { clientOAuth } from '../utils/clientOAuth'

export const SET_LOGIN_INFORMATION = 'SET_LOGIN_INFORMATION';
export const SET_SESSION_INFORMATION = 'SET_SESSION_INFORMATION';
export const SET_CHALLENGE_INFORMATION = 'SET_CHALLENGE_INFORMATION';
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_RESPONSE_ERROR = 'SET_RESPONSE_ERROR';
export const SET_VALIDATE_LOGIN_ERROR = 'SET_VALIDATE_LOGIN_ERROR'
export const SET_LOGIN = 'SET_LOGIN';

export const setLoginInformation = (data) => ({ type: SET_LOGIN_INFORMATION, data });
export const setSessionInformation = (data) => ({ type: SET_SESSION_INFORMATION, data });
export const setChallengeInformation = (data) => ({ type: SET_CHALLENGE_INFORMATION, data });
export const setLoginError = (data) => ({ type: SET_LOGIN_ERROR, data });
export const setLoggedIn = () => ({ type: SET_LOGGED_IN })
export const setResponseError = (data) => ({ type: SET_RESPONSE_ERROR, data });
export const setValidateLoginError = (data) => ({ type: SET_VALIDATE_LOGIN_ERROR, data })
export const setLogin = (data) => ({ type: SET_LOGIN, data })


export const validateLogin = (login, password) => (dispatch) => {
    const request = clientOAuth();
    sessionStorage.setItem('loggedIn', false);
    request.post("/back-tenant/authentification/create-challenge-with-hia-and-ldap",
    {
        login: login,
        password: ""
    }, {
    }).then((response) => {
        if (response.status === 201) {
            if(response.data.challengeDetails !== null){
                let challengeInfo = {...response.data.challengeDetails, ...{challengeReceptionMode : response.data.challengeReceptionMode}};

                dispatch(setLoginInformation(challengeInfo));
                dispatch(setChallengeInformation(response.data.challengeDetails));
                dispatch(setLoginError());
                if (response.data.challengeDetails.context.isPublicPass === true) {
                    // Appel direct à checkChallenge avec réponse vide
                    dispatch(checkChallenge(
                        response.data.challengeDetails.context.challengeId,
                        response.data.challengeDetails.context.userId,
                        ""
                    ));
                }
            }else{     
                dispatch(setResponseError(response.data.message));
                dispatch(setLoginError(response.data.message));   
            }
        }else if(response.status === 404){
            dispatch(setLoginInformation());
            dispatch(setResponseError(response.data.message));
            dispatch(setLoginError("hia.convention.pending"));   
        }else if(response.status === 200){
            dispatch(setLoggedIn());
            sessionStorage.setItem('loggedIn', true); 
        }else{
            dispatch(setLoginInformation());
            dispatch(setLoginError(response.data.message));   
            dispatch(setResponseError(response.data.message));
        }
    }).catch(function (error) {
        if (error.status) {
            dispatch(setLoginError(error.data.message));  
            dispatch(setResponseError(error.data.message)); 
        }else{  
            dispatch(setLoginError(error.response.data.message));  
            dispatch(setResponseError(error.response.data.message)); 
        }        
    })
}

export const getSessionDetails = (sessionId) => (dispatch) => {
    const request = clientOAuth();
    sessionStorage.setItem('loggedIn', false);
    request.get(`/back-tenant/api/v1/sessions/${sessionId}`).then(session => {
        if(session.data.login){
          dispatch(validateLogin(session.data.login));
          dispatch(setSessionInformation(session.data));
        }
      }).catch(error => {
        console.log("Error while getting session details :", error);
      });
}

export const checkChallenge = (challengeId, userId, challengeResponse) => (dispatch) => {
    const request = clientOAuth();
    request.post("/back-tenant/authentification/check-challenge", {
        "challengeId": challengeId,
        "challengeResponse": challengeResponse,
        "userId": userId
      }, {
    })
    .then((response) => {
        if (response.status === 200) {
            dispatch(setLoggedIn());
            sessionStorage.setItem('loggedIn', true);
        }else{
            dispatch(setLoginInformation(response.data.context));
            dispatch(setChallengeInformation(response.data));
            dispatch(setResponseError(response.data.authentificationLdap));
        }
    }).catch(function (error) {
        dispatch(setResponseError(true));        
    })
}

export const answerChallenge = (challengeId, userId, response) => (dispatch) => {

    const request = clientOAuth();
    request.put(`/tenant/api/v1/client-users/challenges?challengeId=${challengeId}&response=${response}&userId=${userId}`, {
    }).then((response) => {
        if (response.status === 200) {
            dispatch(setLoggedIn())
        }
    }).catch(function (error) {
        if (error.response.data.result) {
            dispatch(setResponseError(error.response.data.result));
            dispatch(setChallengeInformation(error.response.data))
        }
        else {
            dispatch(setResponseError(error.response.data.errors[0].key));
        }
    })
}

export const createNewConvention = (login) => (dispatch) => {
    const request = clientOAuth();
    request.post(`/tenant/api/v1/accounts/new-convention`, { login: login }, {
    }).then((response) => {
        if (response.status === 200) {
            dispatch(setValidateLoginError(true));
        }
    }).catch(function (error) {
        if (error.response.data.errors) { dispatch(setValidateLoginError(error.response.data.errors[0].key)); }
    })
}

